import React from 'react';
import { useNavigate } from 'react-router-dom';

function Landing() {
  const navigate = useNavigate();

  // GHL Marketplace installation URL
  const handleInstallApp = () => {
    // Updated with payment/orders scopes for order webhooks (order.create, order.update)
    const ghlMarketplaceUrl = process.env.REACT_APP_GHL_MARKETPLACE_URL ||
      'https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A3001%2Fapi%2Fmarketplace%2Fcallback&client_id=68efb7d55e77e48fc0d68627-mgubw77u&scope=contacts.readonly+contacts.write+locations.readonly+oauth.write+oauth.readonly+opportunities.readonly+opportunities.write+calendars.readonly+users.readonly+workflows.readonly+payments%2Forders.readonly+payments%2Forders.write&version_id=68efb7d55e77e48fc0d68627';

    window.location.href = ghlMarketplaceUrl;
  };

  const handleExistingUserLogin = () => {
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '60px',
        alignItems: 'center'
      }}>
        {/* Left Column - Marketing Content */}
        <div style={{ color: 'white' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            lineHeight: '1.2'
          }}>
            ViRaffle - Viral Raffle Campaigns for GoHighLevel
          </h1>

          <p style={{
            fontSize: '1.3rem',
            marginBottom: '30px',
            opacity: 0.9,
            lineHeight: '1.6'
          }}>
            Create engaging viral raffles, manage entries, and drive explosive customer engagement -
            all seamlessly integrated with your GoHighLevel account.
          </p>

          <div style={{ marginBottom: '40px' }}>
            <h3 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>✨ Key Features:</h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              fontSize: '1.1rem',
              lineHeight: '2'
            }}>
              <li>✓ Unlimited raffle campaigns (Agency plan)</li>
              <li>✓ Automated ticket generation & tracking</li>
              <li>✓ GHL webhook integration for automatic entries</li>
              <li>✓ Public sharing pages for your raffles</li>
              <li>✓ Winner selection & notification system</li>
              <li>✓ Complete analytics & reporting</li>
            </ul>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            padding: '20px',
            borderRadius: '10px',
            backdropFilter: 'blur(10px)'
          }}>
            <p style={{ fontSize: '0.95rem', opacity: 0.9, margin: 0 }}>
              💡 <strong>Trusted by GHL agencies</strong> to run promotional campaigns,
              customer appreciation raffles, and lead generation contests.
            </p>
          </div>
        </div>

        {/* Right Column - CTA Card */}
        <div className="card" style={{
          background: 'white',
          padding: '50px',
          borderRadius: '15px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <h2 style={{
              fontSize: '2rem',
              color: '#333',
              marginBottom: '10px'
            }}>
              Get Started Free
            </h2>
            <p style={{
              color: '#666',
              fontSize: '1.1rem'
            }}>
              Install in your GoHighLevel account
            </p>
          </div>

          {/* Pricing Preview */}
          <div style={{
            background: '#f8f9fa',
            padding: '20px',
            borderRadius: '10px',
            marginBottom: '30px'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <span style={{ color: '#666' }}>Free Plan</span>
              <span style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#667eea'
              }}>$0/mo</span>
            </div>
            <p style={{
              fontSize: '0.9rem',
              color: '#666',
              margin: '0 0 15px 0'
            }}>
              1 raffle per month • 100 entries
            </p>

            <div style={{
              borderTop: '1px solid #dee2e6',
              paddingTop: '15px'
            }}>
              <p style={{
                fontSize: '0.85rem',
                color: '#666',
                margin: 0
              }}>
                <strong>Paid plans from $29/mo</strong><br/>
                Unlock more raffles, unlimited entries & advanced features
              </p>
            </div>
          </div>

          {/* Primary CTA */}
          <button
            onClick={handleInstallApp}
            style={{
              width: '100%',
              padding: '18px',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              marginBottom: '15px',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            🚀 Install from GHL Marketplace
          </button>

          {/* Secondary CTA */}
          <button
            onClick={handleExistingUserLogin}
            style={{
              width: '100%',
              padding: '15px',
              fontSize: '1rem',
              background: 'transparent',
              color: '#667eea',
              border: '2px solid #667eea',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#667eea';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#667eea';
            }}
          >
            Already installed? Login here
          </button>

          {/* Trust Indicators */}
          <div style={{
            marginTop: '30px',
            paddingTop: '20px',
            borderTop: '1px solid #dee2e6',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: '0.85rem',
              color: '#999',
              margin: 0
            }}>
              🔒 Secure OAuth integration • 💳 Stripe & PayPal accepted
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div style={{
        position: 'absolute',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'white',
        opacity: 0.7,
        fontSize: '0.9rem',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0 }}>
          Compatible with GoHighLevel Sub-Accounts & Agency Accounts
        </p>
      </div>
    </div>
  );
}

export default Landing;
